import { DEV_URL_WITH_LANG } from '../const/const';

export const isLocalhost = Boolean(
    window.location.hostname === 'kapinua.test' ||
        window.location.hostname === 'localhost' ||
        // [::1] is the IPv6 localhost address.
        window.location.hostname === '[::1]' ||
        // 127.0.0.1/8 is considered localhost for IPv4.
        window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
        )
);

class ApiEndpoints {
    static GRAPHIC_UPLOAD = (customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphic&ajax&action=uploadGraphics' +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);
    static GRAPHIC_UPLOAD_DELETE = (uploadId, uploadBulkId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphic&ajax&action=deletePreUploadedGraphics' +
        '&uploadId=' +
        uploadId +
        '&uploadBulkId=' +
        uploadBulkId;
    static GRAPHIC_UPLOAD_SUBMIT = (uploadIds, uploadBulkId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphic&ajax&action=activateUploadedGraphics' +
        '&uploadBulkId=' +
        uploadBulkId +
        '&uploadIds=' +
        uploadIds.join('__');
    static GRAPHIC_LIBRARY_DELETE = (
        idGraphic,
        idDesignJson,
        customerId,
        guestId
    ) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphic&ajax&action=deactivateGraphic' +
        '&idGraphic=' +
        idGraphic +
        '&idDesignJson=' +
        idDesignJson +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);
    static KAPINUA_COLORS_LOAD = () =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=onlinedesigner&controller=dataProvider&ajax&type=kapinuaColors';
    static KAPINUA_GRAPHIC_TAGS_LOAD = () =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphicTag&ajax&action=getTags';
    static KAPINUA_GRAPHICS_LOAD = (customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=FrontGraphic&ajax&action=getGraphics' +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);
    static KAPINUA_CUSTOMERS_DESIGNS_LOAD = (
        currentDesignId,
        customerId,
        guestId
    ) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=designsApi&ajax&action=getCustomersDesigns&idCurrentDesign=' +
        currentDesignId +
        (customerId !== null ? '&id_customer=' + customerId : '') +
        (guestId !== null ? '&id_guest=' + guestId : '');
    static LOAD_GARMENTS = (selectedCategoryId, currentGarmentId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=garmentsApi&ajax&action=getGarments' +
        (selectedCategoryId
            ? '&selectedCategoryId=' + selectedCategoryId
            : '') +
        (currentGarmentId ? '&currentGarmentId=' + currentGarmentId : '');
    static PROCESS_DESIGN_SAVE_DESIGN = (
        idProduct,
        idDesign,
        customerId,
        guestId
    ) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=processDesign&action=saveDesign&ajax=1' +
        (idProduct ? '&idProduct=' + idProduct : '') +
        (idDesign ? '&idDesign=' + idDesign : '') +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static PROCESS_DESIGN_SAVE_IMAGES = (
        idProduct,
        idDesign,
        customerId,
        guestId
    ) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=processDesign&action=saveDesignImages&ajax=1' +
        (idProduct ? '&idProduct=' + idProduct : '') +
        (idDesign ? '&idDesign=' + idDesign : '') +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static PROCESS_DESIGN_SAVE_NAME = (idDesign, customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=designsApi&action=saveDesignName&ajax=1' +
        (idDesign ? '&idDesign=' + idDesign : '') +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static GET_PRODUCT = (idProduct, idLanguage, idCurrency) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=garmentsApi&action=getProduct&ajax=1&idProduct=' +
        idProduct +
        '&idLanguage=' +
        idLanguage +
        '&idCurrency=' +
        idCurrency;

    static GET_CART_ITEMS = (customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=designsApi&action=getCart&ajax=1' +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static DELETE_CART_ITEMS = (customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=garments&controller=designsApi&action=deleteCartItem&ajax=1' +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static LOAD_GRAPHIC_SVG = (idGraphic, customerId, guestId) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=svgApi&ajax&action=getSvg' +
        '&idGraphic=' +
        idGraphic +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static SAVE_GRAPHIC_SVG = (
        idGraphic,
        overwrite,
        customerId,
        guestId,
        idLang,
        idDesign
    ) =>
        (isLocalhost ? DEV_URL_WITH_LANG : '') +
        '/index.php?fc=module&module=graphics&controller=svgApi&ajax&action=uploadSvg' +
        '&idGraphic=' +
        idGraphic +
        '&overwrite=' +
        +overwrite +
        (idLang !== null ? '&idLang=' + idLang : '') +
        (idDesign !== null ? '&idDesign=' + idDesign : '') +
        this.CUSTOMER_GUEST_SUFFIX(customerId, guestId);

    static CUSTOMER_GUEST_SUFFIX = (customerId, guestId) =>
        (customerId !== null ? '&id_customer=' + customerId : '') +
        (guestId !== null ? '&id_guest=' + guestId : '');
}

export default ApiEndpoints;
